import React from 'react';

const Footer = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#14272d] text-white">
      <div className="max-w-7xl mx-auto px-5 py-10 md:px-8 lg:px-12">
        <div className="grid gap-8 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-11 h-11 text-2xl bg-white/10 rounded-sm">⭐</div>
              <div>
                <div className="text-lg font-black">Nepal Market</div>
                <div className="text-[10px] tracking-[.16em] text-[#92a3a9] uppercase">Price comparison for Nepal</div>
              </div>
            </div>
            <p className="max-w-md mt-5 text-sm leading-6 text-[#92a3a9]">Search products, compare available offers, and make a better buying decision in Nepal.</p>
          </div>

          <div>
            <h3 className="text-xs font-black tracking-[.18em] uppercase text-white/80">Navigation</h3>
            <div className="flex flex-col gap-3 mt-4 text-sm text-[#92a3a9]">
              <a href="/" className="hover:text-white">Home</a>
              <button type="button" onClick={() => scrollTo('results')} className="text-left hover:text-white">Compare Prices</button>
              <button type="button" onClick={() => scrollTo('categories')} className="text-left hover:text-white">Categories</button>
              <button type="button" onClick={() => scrollTo('why-nepal-market')} className="text-left hover:text-white">Why Nepal Market</button>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-black tracking-[.18em] uppercase text-white/80">Popular</h3>
            <div className="flex flex-col gap-3 mt-4 text-sm text-[#92a3a9]">
              <button type="button" onClick={() => scrollTo('categories')} className="text-left hover:text-white">Mobile Phones</button>
              <button type="button" onClick={() => scrollTo('categories')} className="text-left hover:text-white">Computers</button>
              <button type="button" onClick={() => scrollTo('categories')} className="text-left hover:text-white">Electronics</button>
              <button type="button" onClick={() => scrollTo('categories')} className="text-left hover:text-white">TV & Display</button>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3 pt-6 mt-8 text-xs border-t border-white/10 text-[#66808a] md:flex-row md:justify-between">
          <p>© {new Date().getFullYear()} Nepal Market. All rights reserved.</p>
          <p>Prices and availability may change. Verify details before purchasing.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
